/** @jsxImportSource @emotion/react */
import { useParams } from "react-router";
import { RouteFullScreenModal } from "../../../../components/RouteFullScreenModal";
import { useGetSplitConfiguration } from "../../service/adyen-account-holders-api";
import { SpinnerBlock } from "../../../common/Spinner";
import "react18-json-view/src/style.css";
import JsonView from "react18-json-view";
import { css } from "@emotion/react";
import { ButtonInternalLink } from "../../../../components/NewButtons";
import { Divider } from "../../../../components/Divider";

export const bodyStyle = css`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding-top: 24px;
  padding-bottom: 24px;
  width: 100%;
  align-items: center;
  justify-content: start;
  overflow-y: auto;
`;

export const InspectSplitConfiguration = () => {
  const { splitConfigurationId } = useParams();
  const {
    data: splitConfiguration,
    isLoading: isSplitConfigurationLoading,
  } = useGetSplitConfiguration(splitConfigurationId);

  return (
    <RouteFullScreenModal
      title={splitConfiguration?.description || "Split configuration"}
      actions={<ButtonInternalLink to={".."}>Close</ButtonInternalLink>}
    >
      <Divider />
      {isSplitConfigurationLoading ? (
        <SpinnerBlock />
      ) : (
        <div css={bodyStyle}>
          <JsonView
            src={splitConfiguration}
            css={css`
              width: 100%;
              max-width: 600px;
            `}
          />
        </div>
      )}
    </RouteFullScreenModal>
  );
};
